export default {
  textareaLabel: {
    id: 'review_funnel_question_textarea_label',
    defaultMessage: 'How did it go with your device?',
  },
} as const
